"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZipCode = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Translated = _interopRequireDefault(require("../../Translated"));
var _hooks = require("../../../hooks");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const countryZipCodeRegExpsMap = {
  US: /^(\d){5}$/,
  CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i
};
const ZipCode = _ref => {
  let {
    required: isRequired = false,
    value,
    onChange,
    valid: isValid = true,
    setValid,
    countryCode,
    disabled: isDisabled = false
  } = _ref;
  const intl = (0, _hooks.useIntl)();
  const handleBlur = () => {
    switch (countryCode) {
      case 'US':
      case 'CA':
        {
          setValid(countryZipCodeRegExpsMap[countryCode].test(value));
          break;
        }
      default:
        {
          break;
        }
    }
  };
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, {
    fullWidth: true,
    required: isRequired
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle1"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "postal_code"
  })), /*#__PURE__*/_react.default.createElement(_core.TextField, {
    value: value,
    onChange: onChange,
    disabled: isDisabled,
    error: !isValid,
    helperText: !isValid && intl.formatMessage({
      id: 'invalid_postal_code'
    }),
    onBlur: handleBlur
  }));
};
exports.ZipCode = ZipCode;